<template>
  <button
    type="button"
    class="lv-toggle-chip"
    :class="{
      'lv-toggle-chip--active': value && !disabled,
      'lv-toggle-chip--disabled': disabled,
    }"
    :disabled="disabled"
    :aria-pressed="value ? 'true' : 'false'"
    @click.stop="$emit('input', !value)"
  >
    <i class="lv-toggle-chip__icon" :class="value ? 'icon-check' : 'icon-add'" />
    <span v-if="text" class="lv-toggle-chip__text">{{ $t(text) }}</span>
  </button>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
